import { isString } from 'lodash';
import { makeBenefitsApi } from 'src/http/api/internal/internal-http';
import { BannersRepository } from 'src/repositories/banners/banners.repository';
import { BannerListTypeItem } from 'src/types/banners';
import { toBase64 } from 'src/utils/utils';
import { create } from 'zustand';

type States = {
  isLoadingBannersList: boolean;
  isLoadingBannerDetails: boolean;
  isLoadingUpdateBanner: boolean;
  bannersList: BannerListTypeItem[];
  bannerDetails: BannerListTypeItem | null;
};

type Actions = {
  getBannersList: () => Promise<void>;
  getBannerDetails: (id: string) => Promise<void>;
  updateBanner: (updatedBanner: BannerListTypeItem[]) => Promise<void>;
};

type Banners = Actions & States;

const initialValues = {
  isLoadingBannersList: false,
  isLoadingBannerDetails: false,
  isLoadingUpdateBanner: false,
  bannersList: [],
  bannerDetails: null,
};

const bannersRepository = new BannersRepository(makeBenefitsApi());

export const useBannersStore = create<Banners>((set: any, get: any) => ({
  ...initialValues,

  getBannersList: async () => {
    set({ isLoadingBannersList: true });
    const response = await bannersRepository.getBannersList();

    if (response.isLeft()) {
      set({ isLoadingBannersList: false });
      throw new Error(response.value.message);
    } else {
      set({ bannersList: response.value, isLoadingBannersList: false });
    }
  },

  getBannerDetails: async (id) => {
    set({ isLoadingBannerDetails: true });
    const response = await bannersRepository.getBannerDetails(id);

    if (response.isLeft()) {
      set({ isLoadingBannerDetails: false });
      throw new Error(response.value.message);
    } else {
      set({ bannerDetails: response.value, isLoadingBannerDetails: false });
    }
  },

  updateBanner: async (updatedBanner) => {
    set({ isLoadingUpdateBanner: true });

    if (!isString(updatedBanner[0]?.url[0].urlName)) {
      try {
        const imgBase64: any = await toBase64(updatedBanner[0]?.url[0].urlName);
        const res: any = await bannersRepository.uploadFile({
          name: updatedBanner[0]?.url[0].urlName.name,
          base64: imgBase64,
        });
        updatedBanner[0].url[0].urlName = res.value.data.url;
      } catch (error) {
        console.error(error);
      }
    }

    const response = await bannersRepository.updateBanner(updatedBanner);

    if (response.isLeft()) {
      set({ isLoadingUpdateBanner: false });
      throw new Error(response.value.message);
    } else {
      set({ isLoadingUpdateBanner: false });
    }
  },
}));
